import ListingMETCommissionCompany from "app/pages/Store";
import AuthenticateAndRolesMiddleware from "../Middleware";
import Page from "@jumbo/shared/Page";
import MyCompanyOrder from "app/pages/MyCompanyOrder";
import ListingCompanyOrder from "app/pages/MyCompanyOrder/ListingCompanyOrder";


const routesName = "/dashboards/myStore";

export const storeRoute = [
  {
    middleware: [
      {
        element: AuthenticateAndRolesMiddleware,
        fallbackPath: "/login",
      },
    ],
    routes: [
      {
        path: `${routesName}`,
        element: <Page component={ListingMETCommissionCompany} />
      },
      {
        path: `${routesName}/company-order/:companyId`,
        element: <Page component={MyCompanyOrder} />,
      },
      {
        path: `${routesName}/edit`,
        // element: <Page component={EditCloudstratClient} />,
      },
    ],
  },]
